/* eslint-disable quote-props */
import React from 'react';
import {pulse} from 'react-animations';
import {useSelector} from 'react-redux';
import {makeStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import NoSelect from './no_select';

const useStyles = makeStyles((theme) => ({
  '@keyframes pulse': pulse,
  pulse: {
    animationName: '$pulse',
    animationDuration: '1s',
    animationIterationCount: '2',
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    height: '100%',
  },
  card: {
    margin: '6px',
    verticalAlign: 'middle',
  },
  noselectHeader: {
    userSelect: 'none',
  },
  attack: {
    backgroundColor: '#ed7b84',
  },
  health: {
    backgroundColor: '#c2eaba',
  },
  letter: {
    fontFamily: 'Georgia, serif',
    fontSize: 'x-large',
  },
  middle: {
    verticalAlign: 'middle',
  },
}));

export default function EnemyBox() {
  const classes = useStyles();
  const health = useSelector((state) => state.game.health);
  const drain = useSelector((state) => state.game.drain);
  const foe = useSelector((state) => state.game.foe);
  const notify = useSelector((state) => state.game.notify);

  function drainNotify() {
    return notify.drain ? classes.pulse : '';
  }

  return (
    <Paper className={classes.paper}>
      <Box mb={3}>
        <Typography variant="h5">
          <NoSelect>
            Foe Status
          </NoSelect>
        </Typography>
      </Box>
      <Box>
        <NoSelect>
          <span className={classes.letter}>{foe}</span>
        </NoSelect>
      </Box>
      <Card className={classes.card}>
        <CardHeader className={classes.noselectHeader} title="Health" />
        <CardContent>
          <NoSelect>
            {health}
          </NoSelect>
        </CardContent>
      </Card>
      <Card className={`${classes.card} ${classes.attack} ${drainNotify()}`}>
        <CardContent>
          <Typography variant="h5">
            <NoSelect>
              Drain: {drain}
            </NoSelect>
          </Typography>
        </CardContent>
      </Card>
    </Paper>
  );
};
